{
  "colorSwatchPicker": "Farveprøver",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Vælg et element",
  "tableResizer": "Størrelsesændring"
}
